import { twMerge } from 'tailwind-merge';
import { BenchMarkScoreMetaData } from '../../../../shared/types/widget';
import InfoIcon from '../../../../assets/icons/General/info-Icon.svg?react';

interface BurnoutAlertProps {
  info?: BenchMarkScoreMetaData['meta']['info'];
  className?: string;
}

function BurnoutAlert({ info, className }: BurnoutAlertProps) {
  return (
    <div
      className={twMerge(
        'bg-black-50 border-black-200 flex items-center gap-x-2 rounded-lg border px-3 py-[9px]',
        className,
      )}
    >
      <InfoIcon className="fill-black-600 min-w-5" />
      <span className="text-black-600 text-sm font-medium">{info}</span>
    </div>
  );
}

export default BurnoutAlert;
